import { formatISODate } from '@/src/shared/utils/datetime';
import { safeParseZodObject } from '@/src/shared/utils/parser';
import { TBookServiceSlot } from '../schemas/book-service-slot';
import {
  SCreateBookServiceSlotRequest,
  TCreateBookServiceSlotRequest,
} from '../schemas/request';

export function mapBookServiceToBookServiceRequest(
  input: TBookServiceSlot,
  serviceSlotId: number,
  method: string | null
): TCreateBookServiceSlotRequest {
  return safeParseZodObject<TCreateBookServiceSlotRequest>(
    SCreateBookServiceSlotRequest,
    {
      full_name: input.fullName,
      nik: input.nik,
      phone_number: input.phoneNumber,
      gender: input.gender,
      birth_date: formatISODate(input.birthDate),
      job: input.job,
      address: input.address,
      payment_type: input.paymentMethod,
      treatment_place: input.treatmentPlace,
      has_previous_treatment: input.hasTreatmentInThisClinic,
      discovery_method: input.eventDiscoveryMethods,
      ss_id: serviceSlotId,
      method,
    }
  );
}
